import React from 'react';
import Text from 'design-system/Text';
import ProgressCard from 'features/invest/components/InvestOnboardingFunnel/ProgressCard';
const WithdrawRequestedCard = ({ formattedInitiatedTime, bankName, noticeDays }) => (<ProgressCard lightBg completed noTextDecoration alwaysShowChildren alwaysShowTimeline title="Withdrawal requested" timeInfo={formattedInitiatedTime}>
    <Text Secondary TextThin-14>
      {noticeDays
        ? `We've notified ${bankName} that you'd like to withdraw your funds. Your ${noticeDays}-day notice period starts ${/\d/.test(formattedInitiatedTime) ? formattedInitiatedTime : formattedInitiatedTime.toLowerCase()}.`
        : `We have asked ${bankName} to send us back your funds.`}
    </Text>
  </ProgressCard>);
export default WithdrawRequestedCard;
